import FanPaymentPage from "./FanPaymentPage";

export default FanPaymentPage;
